import { UPDATE_EXTENSION_STATUS } from '@/store/extension/actionTypes';

const PING_INTERVAL = 3000;

export default (store) => {
  function checkExtStatus() {
    return store.dispatch(UPDATE_EXTENSION_STATUS);
  }

  setInterval(checkExtStatus, PING_INTERVAL);
};
